import type { HTMLAttributes } from 'react';

import { cn } from '@/lib/utils/cn';

interface KbdProps extends HTMLAttributes<HTMLElement> {}

/**
 * Keyboard hint badge. Always wrapped in <kbd> for semantic correctness.
 * Used in command palette, action labels, empty states with hotkeys.
 */
export function Kbd({ className, children, ...props }: KbdProps) {
    return (
        <kbd
            className={cn(
                'inline-flex h-5 min-w-[1.25rem] items-center justify-center rounded border border-border bg-muted px-1.5 font-mono text-2xs font-medium text-muted-foreground',
                className,
            )}
            {...props}
        >
            {children}
        </kbd>
    );
}
